export default "__VITE_ASSET__C20iQAvJ__"